<div class="billet-wks-confirmation" [ngClass]="{'isBilletFloat': isBilletFloat}">
  <ng-container *ngIf="!orderSentSuccess; else templateOrderSent">
  <div class="title">
    <span>Olá, deseja confirmar a {{ model.side === 'BUY' ? 'compra' : 'venda' }} abaixo?</span>
  </div>
  <div class="financial">
    <div class="row box" [ngClass]="{'signature-h': isLoginW && fractionaryQtd !==0}">
      <div class="col-12">
        <span class="title">Conta:&nbsp;</span>
        <span class="value">{{ model.account }}</span>
      </div>
      <!-- <div class="col-6">
        <div class="title">Limite Operacional</div>
        <div class="value">{{ limiteOperacional ? limiteOperacional : '-' }}</div>
      </div> -->
    </div>
  </div>
  <div class="scroll"
    [ngClass]="{'scroll-signature': !loadingOrder && isLoginW && !isAssessor, 'billet-float': isBilletFloat }">
    <div class="row">
      <div class="col-12 quote text-center">
        <span class="value">{{ model.company }}</span>
      </div>
      <div class="col-12 separator">
        <div class="line"></div>
      </div>
      <div class="col-12 box-price" *ngIf="!isStop">
        <div id="order1" [ngClass]="{'fz-11': nonFractionary < 999999}" *ngIf="nonFractionary || isTypeOrderMarket">
          <mat-checkbox (change)="fullAssetFlag()" class="mr-1" [(ngModel)]="fullFlag" name="checkfullFlag1">
          </mat-checkbox>
          <span>{{ !model.quote ? "X" : nonFractionaryQtd | number:'1.3-3' }}</span>
          <span>&nbsp;{{ model.market === 1 ? 'ações de ' : 'contrato(s) de' }}&nbsp;</span>
          <span class="value">{{ !model.quote ? "ATIVO " : model.quote + ' '}}</span>
          <span *ngIf="isTypeOrderMarket">
            {{ this.model.timeInForce === timeInForceEnum.GFA ? 'no LEILÃO' :
            this.model.timeInForce === timeInForceEnum.ATC ? 'no FECHAMENTO' : 'a MERCADO' }}</span>
          <span *ngIf="!indiceFuture && !isTypeOrderMarket">a {{ !nonFractionary ? "= X.XXX,XX" : quotePrice
            }}</span>
          <span *ngIf="indiceFuture && !isTypeOrderMarket">a {{ !nonFractionary ? "= X.XXX,XX" : model.price |
            number:'1.0-0' }}</span>
        </div>
        <div id="order2" [ngClass]="{'fz-11': fractionary < 999999}"
          *ngIf="fractionaryQtd !== 0 || (fractionaryQtd !== 0 && isTypeOrderMarket)">
          <mat-checkbox (change)="fractAssetFlag()" class="mr-1" [(ngModel)]="fractFlag" name="checkfractFlag1">
          </mat-checkbox>
          <span>{{ !fractionary ? "X" : fractionaryQtd | number:'1.3-3' }}</span>
          <span>&nbsp;{{ model.market === 1 ? 'ações de ' : 'contrato(s) de' }}&nbsp;</span>
          <span class="value">{{ !fractionary ? "ATIVO " : model.quote + 'F '}}</span>
          <span *ngIf="!isTypeOrderMarket">a {{ model.price }}</span>
          <span *ngIf="isTypeOrderMarket">
            {{ this.model.timeInForce === timeInForceEnum.GFA ? 'no LEILÃO' :
            this.model.timeInForce === timeInForceEnum.ATC ? 'no FECHAMENTO' : 'a MERCADO' }}</span>
        </div>
        <div *ngIf="model.orderStrategy" class="qtd">
          <span>Operação: </span>
          <span>{{ model.orderStrategy | uppercase}}</span>
        </div>
      </div>
      <div class="col-12 box-price" *ngIf="isStop">
        <div id="order2" [ngClass]="{'fz-12': nonFractionary < 999999}" *ngIf="model.stopLoss && nonFractionaryLoss">
          <div class="company2">Stop Loss</div>
          <mat-checkbox (change)="fullAssetFlagLoss()" class="mr-1" [(ngModel)]="fullFlagLoss" ngModel
            name="checkfullFlagLoss1"></mat-checkbox>
          <span>{{ !model.quote ? "X" : nonFractionaryQtdLoss | number:'1.3-3' }}</span>
          <span>&nbsp;{{ model.market === 1 ? 'ações de ' : 'contrato(s) de' }}&nbsp;</span>
          <span class="value"> {{ !model.quote ? "ATIVO " : model.quote + ' '}}</span>
          <span *ngIf="!indiceFuture">a {{ !nonFractionaryLoss ? "= X.XXX,XX" : model.stoptrigger | number }}</span>
          <span *ngIf="indiceFuture">a
            {{ !nonFractionaryLoss ? "= X.XXX,XX" : model.stoptrigger | number:'1.0-0' }}</span>
        </div>
        <div id="order1" [ngClass]="{'fz-12': nonFractionary < 999999}"
          *ngIf="fractionaryQtdLoss !== 0 && model.stopLoss">
          <div class="company2" *ngIf="!nonFractionaryLoss">Stop Loss</div>
          <mat-checkbox (change)="fractAssetFlagLoss()" class="mr-1" [(ngModel)]="fractFlagLoss"
            name="checkfractFlagLoss1"></mat-checkbox>
          <span>{{ !fractionaryLoss ? "X" : fractionaryQtdLoss | number:'1.3-3' }}</span>
          <span>&nbsp;{{ model.market === 1 ? 'ações de ' : 'contrato(s) de' }}&nbsp;</span>
          <span class="value"> {{ !fractionaryLoss ? "ATIVO " : model.quote + 'F '}}</span>
          <span *ngIf="!indiceFuture">a {{ !fractionaryLoss ? "= X.XXX,XX" : model.stoptrigger | number }}</span>
          <span *ngIf="indiceFuture">
            a {{ !fractionaryLoss ? "= X.XXX,XX" : model.stoptrigger | number:'1.0-0' }}
          </span>
        </div>
        <div id="order3" [ngClass]="{'fz-12': nonFractionary < 999999}" *ngIf="nonFractionaryGain && model.stopGain">
          <div class="company2">Stop Gain</div>
          <mat-checkbox (change)="fullAssetFlagGain()" class="mr-1" [(ngModel)]="fullFlagGain"
            name="checkfullFlagGain1"></mat-checkbox>
          <span class="value">{{ !model.quote ? "X" : nonFractionaryQtdGain | number:'1.3-3' }}</span>
          <span>&nbsp;{{ model.market === 1 ? 'ações de ' : 'contrato(s) de' }}&nbsp;</span>
          <span class="value"> {{ !model.quote ? "ATIVO " : model.quote + ' '}}</span>
          <span *ngIf="!indiceFuture">
            a {{ !nonFractionaryGain ? "= X.XXX,XX" : model.targettrigger | number }}
          </span>
          <span *ngIf="indiceFuture">a
            {{ !nonFractionaryGain ? "= X.XXX,XX" : model.targettrigger | number:'1.0-0' }}</span>
        </div>
        <div id="order4" [ngClass]="{'fz-12': nonFractionary < 999999}"
          *ngIf="fractionaryQtdGain !== 0 && model.stopGain">
          <div class="company2" *ngIf="!nonFractionaryGain">Stop Gain</div>
          <mat-checkbox (change)="fractAssetFlagGain()" class="mr-1" [(ngModel)]="fractFlagGain"
            name="checkfractFlagGain1"></mat-checkbox>
          <span class="value">{{ !fractionaryGain ? "X" : fractionaryQtdGain | number:'1.3-3' }}</span>
          <span>&nbsp;{{ model.market === 1 ? 'ações de ' : 'contrato(s) de' }}&nbsp;</span>
          <span class="value"> {{ !fractionaryGain ? "ATIVO " : model.quote + 'F '}}</span>
          <span *ngIf="!indiceFuture">a {{ !fractionaryGain ? "= X.XXX,XX" : model.targettrigger | number }}</span>
          <span *ngIf="indiceFuture">a {{ !fractionaryGain ? "= X.XXX,XX" : model.targettrigger | number:'1.0-0'
            }}</span>
        </div>
      </div>
      <div class="col-12 separator">
        <div class="line"></div>
      </div>
      <div class="col-12 box-total">
        <div class="title">
          <span *ngIf="model.market !== 3">Valor:&nbsp;</span>
          <span class="price" *ngIf="model.market !== 3 && !isStop && !indiceFuture">{{ totalDisplay == 0 ||
            isTypeOrderMarket ? "-" : totalDisplay | number }}</span>
          <span class="price" *ngIf="model.market !== 3 && !isStop && indiceFuture">{{ totalDisplay == 0 ||
            isTypeOrderMarket ? "-" : totalDisplay | number:'1.0-0' }}</span>
          <div class="divTotalLoss"
            *ngIf="model.market !== 3 && isStop && !indiceFuture && ((model.stopGain && model.stopLoss) || model.stopLoss)">
            <span class="valueStop"><span class="company2">Loss:&nbsp;</span>
              {{ totalDisplayLoss == 0 ? "-" : totalDisplayLoss | number }}</span>
          </div>
          <div class="divTotalLoss"
            *ngIf="model.market !== 3 && isStop && indiceFuture && ((model.stopGain && model.stopLoss) || model.stopLoss)">
            <span class="valueStop"><span class="company2">Loss:&nbsp;</span>
              {{ totalDisplayLoss == 0 ? "-" : totalDisplayLoss | number:'1.0-0' }}</span>
          </div>
          <div class="divTotalLoss"
            *ngIf="model.market !== 3 && isStop && !indiceFuture && ((model.stopGain && model.stopLoss) || model.stopGain)">
            <span class="valueStop"><span class="company2">Gain:&nbsp;</span>
              {{ totalDisplayGain == 0 ? "-" : totalDisplayGain | number }}</span>
          </div>
          <div class="divTotalLoss"
            *ngIf="model.market !== 3 && isStop && indiceFuture && ((model.stopGain && model.stopLoss) || model.stopGain)">
            <span class="valueStop"><span class="company2">Gain:&nbsp;</span>
              {{ totalDisplayGain == 0 ? "-" : totalDisplayGain | number:'1.0-0' }}</span>
          </div>
          <div class="price" *ngIf="brokerageValue && model.market !== 3">Corretagem: {{ brokerageValueDisplay }}
          </div>
          <span *ngIf="brokerageValue && model.market !== 3">Total:&nbsp;</span>
          <span class="price" *ngIf="brokerageValue && model.market !== 3">{{ totalDisplayBrokerage == 0 ? "-" :
            totalDisplayBrokerage | number }}</span>
          <div class="date">Validade: {{ !model.validityOrder ? "-" : model.validityOrder | date: 'dd/MM/yyyy'}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="buttons" [ngClass]="{'m-btn-float': isBilletFloat}">
    <div class="bottom-btn">
      <div *ngIf="isRequest" class="spinner">
        <mat-spinner class="spinner" diameter="38" color="spinner-white"></mat-spinner>
      </div>
      <button *ngIf="!isRequest" mat-raised-button color="send-confirm" class="xms full"
        (click)="verifyEletronicSignature()" [disabled]="isRequest || disableConfirmButton()">
        Confirmar {{ model.side === 'BUY' ? 'COMPRA' : 'VENDA' }}</button>
    </div>
  </div>
  </ng-container>
</div>

<ng-template #templateOrderSent>
  <div class="title">
    <span></span>
  </div>
  <div class="scroll order-sent p-0" [ngClass]="{'billet-float': isBilletFloat}">
    <div class="row">
      <div class="col-12 quote text-center">
        <span class="confirmation-message">Ordem de {{ model.side === 'BUY' ? 'compra' : 'venda' }} enviada com sucesso!</span>
      </div>
      <div class="col-12 bottom-btn">
        <button mat-raised-button color="send-confirm" class="xms full" (click)="confirmClose()">Voltar para boleta</button>
      </div>
    </div>
  </div>
</ng-template>
